module.exports = __webpack_public_path__ + "img/20190701154955043.af45516c.png";